function joinPath(path1: string, path2: string): string {
  return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
}

export { joinPath };
